import React from "react"
import TickBox from "./Tickbox"

const BasicCheckbox = ({ input, type, label, brandColor, meta: { touched, error } }) => (
  <div className="basic-checkbox">
    <div className="checkbox-and-label">
      <TickBox input={input} brandColor={brandColor} />
        <label className="checkbox-label" htmlFor={input.name} >{label}
        </label>
      </div>
    <div className="error-message">{error}</div>
  </div>
);

export default BasicCheckbox;